exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BlqEHRYwnUuMN9XMM9t5t{width:400px}html[dir] ._3Wu9RrV6WpNPmm0NyglWas{margin-top:10px}", ""]);

// exports
exports.locals = {
	"textbox": "BlqEHRYwnUuMN9XMM9t5t",
	"checkbox": "_3Wu9RrV6WpNPmm0NyglWas"
};